(function( $ ) {
    'use strict';

    if (window.location.href.indexOf("my-account/overview") === -1) {
        // only run this on the appropriate page
        return;
    }

    $( window ).load(function() {
        document.addEventListener(
            'click',
            async function(event) {
                if (!event.target.matches('#dob-form-submit')) {
                    return;
                }

                const day = document.querySelector('input[name="day"]')
                const month = document.querySelector('input[name="month"]')
                const year = document.querySelector('input[name="year"]')

                if (!window.utils.dates.validate(day, month, year)) {
                    return;
                }

                window.utils.animations.addLoadingSpinner(document.querySelector('body'));
                await window.customer.setDob(day.value, month.value, year.value);

                // reload the page after setting DOB
                window.location.reload()
            }
        );
    });
})( jQuery );